// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2Z9pq","load6":"Spinner_load6__edmC8","round":"Spinner_round__1Y9Xq"};